module.exports = __webpack_public_path__ + "img/HC1019-25.336fa30e.jpg";